// extracted by mini-css-extract-plugin
export default {"container":"EEg4Et","arrow":"h2262T"};